import React from "react"

import { Grid } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

const WabaAccountInfoCardsSkeleton: React.FC = () => {
	return (
		<Grid
			container
			direction="column"
			spacing={5}
		>
			<Grid item>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<Skeleton height={150} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
					<Grid item xs={4}>
						<Skeleton height={150} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
					<Grid item xs={4}>
						<Skeleton height={150} style={{ borderRadius: 4 }} variant="rect" />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default WabaAccountInfoCardsSkeleton
